package util

import kotlin.js.Date

fun timeSince(epoch: Double) = (Date().getTime() - Date(epoch).getTime())

fun timeSinceDisplay(epoch: Double): String = (timeSince(epoch) / 1000).toLong().display()

fun timeBetween(first: Double, second: Double) = Date(second).getTime() - Date(first).getTime()

fun timeBetweenDisplay(first: Double, second: Double): String = (timeBetween(first, second) / 1000).toLong().display()

fun isMerge(commitSubject: String) = commitSubject.lowercase().startsWith("merge")

fun Long.display(): String {
    val sTot = this
    if (sTot <= 0) return ""
	val d = (sTot / 86400).let { if (it > 0) "$it days " else "" }
	val h = ((sTot / 3600) % 24).let { if (it > 0) "$it hours " else "" }
    val m = ((sTot / 60) % 60).let { if (it > 0) "$it min " else "" }
    val s = (sTot % 60).let { if (it > 0) "$it sec" else "" }
	return "$d$h$m$s".trim()
}

// Returns an empty string if commit URL could not be generated
// e.g. ssh://git@ssh.bitbucket.org/passman/flowr.git, git@github.com:taktik/git-version.git, https://someone@bitbucket.org/passman/qi.git
fun getCommitUrl(cloneUrl: String, commitId: String): String {
    if (commitId.isBlank()) return ""
    val strippedUrl = cloneUrl.trim().removePrefix("https://").removePrefix("ssh://").substringAfter('@').removeSuffix(".git").replace(':', '/')
    val splitUrl = strippedUrl.split("/").takeIf { c -> c.size == 3 && c.none { it.isBlank() } } ?: return ""

    return when (splitUrl[0]) {
        "bitbucket.org", "ssh.bitbucket.org" -> "https://bitbucket.org/${splitUrl[1]}/${splitUrl[2]}/commits/$commitId"
        "git.taktik.be" -> "https://bitbucket.taktik.be/projects/${splitUrl[1]}/repos/${splitUrl[2]}/commits/$commitId"
        "github.com" -> "https://github.com/${splitUrl[1]}/${splitUrl[2]}/commit/$commitId"
        else -> ""
    }
}
